/**
 * Utility function to get sorted translated languages.
 * Places 'Original' first, then sorts other languages alphabetically.
 */
export const getSortedTranslatedLanguages = (
  initialTranslatedLanguages: string[],
  translatedLanguages: string[],
): string[] => {
  return [
    initialTranslatedLanguages[0], // Usually 'Original'
    ...translatedLanguages
      .filter((language) => language !== 'Original')
      .sort((a, b) => a.localeCompare(b)),
  ];
};
